// ** IMPORTANT **: Keep in sync with functions/src/postAccessConstants.ts
export const LOCKED_UNTIL_INDEFINITE = 253_402_300_799_999;

/**
 * Identifies the epoch-millisecond sentinel used for a manual-release lock.
 */
export const isLockedUntilIndefinite = (
    lockedUntil?: number | null,
): boolean => lockedUntil === LOCKED_UNTIL_INDEFINITE;
